import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right-arrow-forward",
  "use": "right-arrow-forward-usage",
  "viewBox": "0 0 408 408",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 408 408\" id=\"right-arrow-forward\"><path d=\"M204 0l-35.7 35.7 142.8 142.8H0v51h311.1L168.3 372.3 204 408l204-204z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol